module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/hidden-keys.js
// module id = 139
// module chunks = 0